<template>
  <path
    d="M4.40999 22.0003H20C21.1 22.0003 22 21.1003 22 20.0003V4.41026C22 3.52026 20.92 3.07026 20.29 3.70026L3.70999 20.2903C3.07999 20.9203 3.51999 22.0003 4.40999 22.0003Z"
  />
</template>
